/** Berufsrakete brand tokens – matched to Figma main page */
export const BR = {
  purple: "#87349D",
  purpleDark: "#6E2A82",
  purpleLight: "#9B59C4",
  purpleIndigo: "#5F57FB",
  purpleGradient: "linear-gradient(90deg, #87349D 0%, #5F57FB 100%)",
  purpleGradientAngle: "linear-gradient(120deg, #87349D 0%, #5F57FB 100%)",
  gold: "#FFC632",
  goldAlt: "#F5C518",
  goldDark: "#E0A800",
  orange: "#E06C4F",
  pink: "#F2A5C0",
  blue: "#5F57FB",
  blueLight: "#B0D0F0",
  bg: "#FFFFFF",
  bgAlt: "#F8F4FC",
  bgMuted: "#F3F0F8",
  text: "#44444F",
  textMuted: "#92929D",
  white90: "#F9FAFB",
  border: "#E5E7EB",
  shadow: "0px 4px 20px 0px rgba(135, 52, 157, 0.1)",
  shadowPurple: "0px 4px 10px rgba(135, 52, 157, 0.15)",
  shadowCta: "0px 4px 5px rgba(135, 52, 157, 0.4)",
  dotGrid: "rgba(135, 52, 157, 0.15)",
} as const;

export const BR_FONT = "'Poppins', 'Nunito', system-ui, sans-serif";

export const BR_ASSETS = {
  heroRocket: "/assets/berufsrakete/hero-rocket-moon.png",
  planetLeft: "/assets/berufsrakete/planet-left.png",
  planetEarth: "/assets/berufsrakete/planet-earth.png",
  planetCta: "/assets/berufsrakete/planet-cta.png",
  planetSmall: "/assets/berufsrakete/planet-small.png",
  satellite: "/assets/berufsrakete/satellite.png",
  astronautLaptop: "/assets/berufsrakete/astronaut-laptop.png",
  logoSymbol: "/assets/berufsrakete/logo-symbol.png",
  logoHorizontal: "/assets/berufsrakete/logo-horizontal.png",
  starsBg: "/assets/berufsrakete/stars-bg.png",
  planetJourney: "/assets/berufsrakete/planet-journey.png",
  ufoAstronaut: "/assets/berufsrakete/ufo-astronaut.png",
  rocketStats: "/assets/berufsrakete/rocket-stats.png",
  astronautFaq: "/assets/berufsrakete/astronaut-faq.png",
  stepIcon1: "/assets/berufsrakete/step-icon-1.svg",
  stepIcon2: "/assets/berufsrakete/step-icon-2.svg",
  stepIcon3: "/assets/berufsrakete/step-icon-3.svg",
  stepIcon4: "/assets/berufsrakete/step-icon-4.svg",
  whyIcon1: "/assets/berufsrakete/why-icon-1.svg",
  whyIcon2: "/assets/berufsrakete/why-icon-2.svg",
  whyIcon3: "/assets/berufsrakete/why-icon-3.svg",
  whyIcon4: "/assets/berufsrakete/why-icon-4.svg",
  whyIcon5: "/assets/berufsrakete/why-icon-5.svg",
  whyIcon6: "/assets/berufsrakete/why-icon-6.svg",
  courseCard1: "/assets/berufsrakete/course-card-1.png",
  courseCard2: "/assets/berufsrakete/course-card-2.png",
  courseCard3: "/assets/berufsrakete/course-card-3.png",
  courseCard4: "/assets/berufsrakete/course-card-4.png",
  journeyPath: "/assets/berufsrakete/journey-path.svg",
  journeyDots: "/assets/berufsrakete/journey-dots.svg",
  glowPink: "/assets/berufsrakete/glow-pink.svg",
  glowBlue: "/assets/berufsrakete/glow-blue.svg",
  arrowWhite: "/assets/berufsrakete/arrow-white.svg",
  arrowDark: "/assets/berufsrakete/arrow-dark.svg",
  heroPhotoSimulation: "/assets/berufsrakete/hero-photo-simulation.png",
  decorTelescope: "/assets/berufsrakete/decor-telescope.png",
  decorCapsule: "/assets/berufsrakete/decor-capsule.png",
  decorRocketMini: "/assets/berufsrakete/decor-rocket-mini.png",
  decorAstronautFloat: "/assets/berufsrakete/decor-astronaut-float.png",
  decorPlanetSaturn: "/assets/berufsrakete/decor-planet-saturn.png",
  decorPlanetSwirl: "/assets/berufsrakete/decor-planet-swirl.png",
  decorMoonFlag: "/assets/berufsrakete/decor-moon-flag.png",
  decorPlanetCluster: "/assets/berufsrakete/decor-planet-cluster.png",
  decorAsteroidCluster: "/assets/berufsrakete/decor-asteroid-cluster.png",
} as const;
